import { Single as SingleCatalog } from './Single';

export default SingleCatalog;
